import React, { useEffect, useState } from "react";
import {
  DEV_AUTH_CHANGE_EVENT,
  getDevAuthSession,
  isDevAuthEnabled,
  setDevAuthSession,
} from "devAuth";

// Visible only when REACT_APP_DEV_AUTH=1 and a session is active. Sits in the
// bottom-right corner across the whole app so the developer can drop the
// impersonation from any page.
const DevAuthBadgeImpl: React.FC = () => {
  const [session, setSession] = useState(() => getDevAuthSession());

  useEffect(() => {
    if (!isDevAuthEnabled()) return;
    const sync = () => setSession(getDevAuthSession());
    window.addEventListener(DEV_AUTH_CHANGE_EVENT, sync);
    return () => window.removeEventListener(DEV_AUTH_CHANGE_EVENT, sync);
  }, []);

  if (!isDevAuthEnabled() || !session) return null;

  return (
    <div className="fixed bottom-3 right-3 z-50 flex items-center gap-2 rounded-full border border-amber-600 bg-amber-50/95 px-3 py-1.5 shadow-md backdrop-blur">
      <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-amber-700">
        DEV
      </span>
      <span className="font-body text-[12px] text-slate-800">{session.email}</span>
      <button
        type="button"
        onClick={() => setDevAuthSession(null)}
        className="rounded-full bg-amber-600 px-2.5 py-0.5 font-manrope text-[10px] uppercase tracking-[0.18em] text-white hover:bg-amber-700"
      >
        Logout
      </button>
    </div>
  );
};

const DevAuthBadgeNoop: React.FC = () => null;

// Module-level swap: in production the badge resolves to a no-op component
// and DevAuthBadgeImpl becomes unreferenced. CRA + Terser then drop the impl
// (and its JSX literals) from the bundle, while keeping all hook calls
// unconditional within whichever component is actually used at runtime.
const DevAuthBadge: React.FC =
  process.env.NODE_ENV === "production" ? DevAuthBadgeNoop : DevAuthBadgeImpl;

export default DevAuthBadge;
